import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    domains: [],
    selected: null,
    fetching: true
  },
  mutations: {
    set (state, domains) {
      state.domains = domains
    },
    setSelected (state, domain) {
      state.selected = domain
    }
  },
  actions: {
    fetch ({ state, commit }) {
      state.feching = true

      apiService.getClientDomains()
        .then(response => {
          commit('set', response.data.domains)
          window.vue.$emit('clientDomainsLoaded')

          state.fetching = false
        })
        .catch(() => {
          state.fetching = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список доменов.'
          })
        })
    },
    changeSelected ({ state, commit, dispatch }, selected) {
      commit('setSelected', selected)
      window.vue.$emit('clientDomainsSelectedChange')
    }
  },
  getters: {
    withoutSelected: (state) => {
      return state.domains.filter((domain) => domain !== state.selected)
    },
    count: (state) => state.domains.length
  }
}
